import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, Divider, Form, Modal, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { CheckOutlinedIcon, DeleteOutlinedIcon } from 'components';
import { useRoleValue } from 'context';
import { deleteRole } from 'services';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    ROLES: { BASE_URL: ROLES_BASE_URL },
  },
} = PATHNAME;

const RoleFormAction = () => {
  const [deleteModalInstance, deleteModalContextHolder] = Modal.useModal();
  const [deleteLoading, { toggle: toggleDeleteLoading }] = useBoolean();
  const { id, mode } = useRoleValue();
  const navigate = useNavigate();

  const handleDeleteRole = useLockFn(
    async ({ id }: Pick<Required<ReturnType<typeof useRoleValue>>, 'id'>) => {
      toggleDeleteLoading();

      deleteRole({ id })
        .then(() => {
          navigate(ROLES_BASE_URL);
          notification.success({
            message: 'دسترسی با موفقیت حذف شد.',
          });
        })
        .catch(message => {
          notification.error({
            message,
          });
        })
        .finally(() => {
          toggleDeleteLoading();
        });
    },
  );

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار دسترسی
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید دسترسی ساخته شده و یا ویرایش شده را منتشر
          کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        {mode === 'Update' ? (
          <Form.Item>
            <Button
              block
              danger
              className='flex items-center'
              loading={deleteLoading}
              icon={<DeleteOutlinedIcon />}
              onClick={async () => {
                const confirmed = await deleteModalInstance.confirm({
                  title: 'آیا از حذف این دسترسی اطمینان دارید؟',
                  width: 500,
                });
                if (id && confirmed) {
                  handleDeleteRole({ id });
                }
              }}
            >
              <span>حذف دسترسی</span>
            </Button>
            {deleteModalContextHolder}
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن دسترسی جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { RoleFormAction };
